var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-page-disbursements__container"},[_c('ReportsDashboardMetric',{attrs:{"value":_vm.data.week,"format":"currency","legend":"denne uken","small":""}}),_c('ReportsDashboardMetric',{attrs:{"value":_vm.data.month,"format":"currency","legend":"denne måneden","small":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }